<template>
    <div class="dest-alt-main">

        <div v-if="DestAltNotamTextList &&DestAltNotamTextList.WeatherText" class="notification is-white">
            <hr>
            <pre>{{WeatherText}}</pre>
            <hr>
        </div>
        <div v-else-if = "DestAltICAO && !DestAltNotamTextList.WeatherText" class="notification is-white">
            <hr>
            <p style="color: red;margin-left: 40px">  {{DestAltICAO}} : weather data not found</p>
            <hr>
        </div>
        <div v-else-if = "!DestAltICAO" class="notification is-white">
            <hr>
            <p style="color: red;margin-left: 40px">  There is no Dest Alternate for this flight.</p>
            <hr>
        </div>

        <div class="notification is-white" v-for="(NotamInfo,idx) in NotamList" :key="idx">
            <p><span @click="favEvent(NotamInfo)" class="icon"><font-awesome-icon icon="star" size="2x"/></span></p>
            <br>
            <p><span @click="modalevent(NotamInfo)" class="icon"> <font-awesome-icon icon="search-plus" size="2x"/></span></p>
            <pre v-html="getValueWithImportantWord(NotamInfo.NotamInfo)"></pre>
            <hr>
        </div>

        <div class="modal" :class="{'is-active': showModalFlag}">
            <button @click="modalevent()" class="modal-close is-large" aria-label="close"></button>
            <div class="modal-background"></div>
            <div class="modal-content">
                <pre class="modal-windows">{{modaldata}}</pre>

            </div>

        </div>
    </div>
</template>

<script>
    import {mapMutations, mapState} from "vuex";

    export default {
        name: "DESTALL",
        props: ["id", "flight"],
        data() {
            return {
                selectedNotams: [1],
                showModalFlag : false,
                modaldata :"",
                WeatherText : "",
                DestAltNotamTextList: null,
                NotamList : null,
                DestAltICAO :""

            }
        },
        created() {

            let DEST_ALTIcao = this.EFF_Json_Data.poOFP.ARR_alt1;
            let splittedNotamTextList = this.WR_Json_Data.LIST_USED_AIRPORTS;
            this.DestAltNotamTextList = splittedNotamTextList.find(x=>x.AirportIcao == DEST_ALTIcao);

            if (this.DestAltNotamTextList === undefined)
            {
                return;
            }

            this.DestAltICAO = this.DestAltNotamTextList.AirportIcao;
            this.NotamList = this.DestAltNotamTextList.NotamInfoList;
            this.WeatherText = this.DestAltNotamTextList.WeatherText;

            return splittedNotamTextList;

        },
        computed: {
            ...mapState("ipadmain",["FKey1", "selectedFlightItems","EFF_Json_Data","WR_Json_Data","NotamImportantList"]),
            ...mapState("dep",["OfpFlightJsonData","NotamWebJsonData","NotamTextForDESTALT","NotamTextsByAirports","NotamDb"]),

        },
        methods:{
            ...mapMutations("selectednotams",["set_favNotam_data"]),

            getValueWithImportantWord(value)
            {
                var i;
                for (i = 0; i < this.NotamImportantList.length; i++) {
                    this.NotamImportantList[i]
                    value=value.replaceAll(this.NotamImportantList[i].word.toString().toUpperCase(),"<span style='color: "+this.NotamImportantList[i].color+";font-weight: '"+this.NotamImportantList[i].style+"'>"+this.NotamImportantList[i].word.toString().toUpperCase()+"</span>");
                }

                return value;
            },

            favEvent(text)
            {

                this.set_favNotam_data(text);

            },
            modalevent(text)
            {

                this.showModalFlag = !this.showModalFlag;
                this.modaldata = text;

            }

        }
    }
</script>

<style scoped>
    .modal-windows{
        background-color: #3892bd;
        color: unset;
        font-size: 1.2rem;
        padding: unset;
        font-weight: bold;

    }
    .modal{
        position: sticky;
        background-color: #fff;
        color: #fff;
        top: 15%;
        border-radius: .25rem;
        left: 10%;
        bottom: 40%;
        width: 80%;
        height: 15%;
    }
    .modal-close{
        height: 37px;
        width: 37px;
        position: sticky;
        left: 92%;
        z-index: 999;
        background-color: #999999;
    }
    .modal-background{
        background-color: #3892bd;
    }
    .modal-content{
        padding: 1.2rem;
    }
</style>
